import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import ApproveSpendButton from '@/components/ApproveSpendButton.vue';
import BuyButton from '@/components/BuyButton.vue';
import CollectButton from '@/components/CollectButton.vue';
import Frame from '@/components/Frame.vue';
import SignaturePromptButton from '@/components/SignaturePromptButton.vue';
import { SignatureSchema, useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimBuyOnlyBody',
  setup(__props) {

const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, { class: "m-project" }, {
    default: _withCtx(() => [
      (_unref(store).erc20Address && _unref(store).erc20ApprovedSpend.lt(_unref(store).cost))
        ? (_openBlock(), _createBlock(ApproveSpendButton, { key: 0 }))
        : (
        _unref(store).signatureSchema == _unref(SignatureSchema).REDEMPTION_CODES && !_unref(store).redemptionCodeValidated
      )
          ? (_openBlock(), _createBlock(SignaturePromptButton, { key: 1 }))
          : (_openBlock(), _createBlock(BuyButton, {
              key: 2,
              class: _normalizeClass({ 'm-claim__action-button': !_unref(store).hasSecondary })
            }, null, 8, ["class"])),
      (_unref(store).hasSecondary)
        ? (_openBlock(), _createBlock(CollectButton, {
            key: 3,
            class: _normalizeClass({ 'm-claim__action-button': _unref(store).hasSecondary })
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})